import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { SnackbarService } from '../../core/services/snackbar/snackbar.service';
import {
  addVehicles,
  addVehiclesFailed,
  deleteVehicle,
  deleteVehicleFailed,
  editStateRegistrationDate,
  editStateRegistrationDateFailed,
  editVehicles,
  editVehiclesReceived,
  getVehicles,
  getVehiclesFailed,
  getVehiclesReceived,
  submitVehicleForReview,
  submitVehicleForReviewFailed,
} from '../actions/vehicleActions';
import { VehicleService } from '../../core/services/vehicle/vehicle.service';
import { convertStringToObject } from '../../core/utilities/utilities';
import { showPopup } from '../actions/operatingAuthorityAction';
@Injectable()
export class vehicleEffect {
  constructor(
    private actions: Actions,
    private vehicleService: VehicleService,
    private snackbarService: SnackbarService,
  ) {}
  vehicleDetails$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        getVehicles,
        addVehicles,
        editVehicles,
        deleteVehicle,
        editStateRegistrationDate,
        submitVehicleForReview,
      ),
      mergeMap((params) => {
        const userData: any = JSON.parse(
          localStorage.getItem('userData') || '',
        );
        if (params.type === 'get-vehicles') {
          return this.vehicleService
            .getVehiclesService(userData?.sessionHash, params.params)
            .pipe(
              map((data: any) => {
                return getVehiclesReceived({ params: data });
              }),
              catchError((error) => of(getVehiclesFailed())),
            );
        } else if (params.type === 'add-vehicle') {
          return this.vehicleService
            .addVehiclesService(userData?.sessionHash, params)
            .pipe(
              mergeMap((data: any) => {
                this.snackbarService.success(
                  'Vehicle has been Added successfully' + ' - ' + data,
                );
                return of(
                  getVehicles({ params: params.params.permitId }),
                  showPopup({ params: true }),
                );
              }),
              catchError((error) => {
                this.snackbarService.danger(error);
                return of(addVehiclesFailed(), showPopup({ params: false }));
              }),
            );
        } else if (params.type === 'edit-vehicle') {
          return this.vehicleService
            .editVehiclesService(userData?.sessionHash, params)
            .pipe(
              map((data: any) => {
                this.vehicleService
                  .getVehicleWithId({
                    id: params.params.vehicleId,
                    sessionHash: userData.sessionHash,
                  })
                  .subscribe((updatedData) => {
                    this.snackbarService.success(
                      'Vehicle has been updated successfully',
                    );
                    const parsedData = convertStringToObject(updatedData);
                    this.vehicleService.selectedVehicleDetails = parsedData;
                  });
                return editVehiclesReceived();
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(addVehiclesFailed());
              }),
            );
        } else if (params.type === 'delete-vehicle') {
          return this.vehicleService
            .deleteVehicleService(userData?.sessionHash, params.params)
            .pipe(
              map((data) => {
                this.snackbarService.danger(
                  'Vehicle has been terminated successfully',
                );
                return getVehicles({ params: params.permitId });
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(deleteVehicleFailed());
              }),
            );
        } else if (params.type === 'edit-state-registration-date') {
          return this.vehicleService
            .editStateRegistrationDateService(userData?.sessionHash, params)
            .pipe(
              map((data) => {
                this.snackbarService.success(
                  'Vehicle State Registration Date has been updated successfully',
                );
                return getVehicles({ params: params.permitId });
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(editStateRegistrationDateFailed());
              }),
            );
        } else if (params.type === 'submit-vehicle-for-review') {
          return this.vehicleService
            .submitVehicleForReviewService(userData?.sessionHash, params.params)
            .pipe(
              map((data) => {
                this.snackbarService.success(
                  'Vehicle has been submitted for review successfully',
                );
                return getVehicles({ params: params.permitId });
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(submitVehicleForReviewFailed());
              }),
            );
        }
        return of({ type: '[Company API] Unknown Action' });
      }),
    ),
  );
}
